// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"47d910f2","629":"b118950c","774":"da317413","787":"6c378e7d"}[chunkId] + ".chunk.js";
};